import React from 'react';
import RadioComponent from '../../../fieldComponents/radioComponent/RadioComponent';
import Card from '../../card/Card';
import { PacketType } from '../../../@types/Packet.type';
import { useAuth } from '../../context/AuthContext/AuthContext';
import { useAppInsightConsumer } from '../../context/AppInsightContext/AppInsightContext';
import {
  appStateActions,
  useAppDispatch,
  useAppSelector,
} from '../../../store/store';
import { AirlineType } from '../../../enums/enum';

const Packet: React.FC = () => {
  const dispatch = useAppDispatch();
  const { reqValidity, packetReqLoading, airlineTypeData } = useAppSelector(
    (state) => state.appStateReducer,
  );

  const { userData } = useAuth();
  const { trackEvent } = useAppInsightConsumer();

  const handlePacketRadioData = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    trackEvent(
      `${event?.target?.value} packet type is selected by ${userData?.profile?.email}`,
    );

    // Update the global printer state
    dispatch(
      appStateActions.updatePacketTypeData(event?.target?.value as PacketType),
    );
  };

  const packetTypeOptions = (
    <>
      <RadioComponent
        componentName="packet"
        label="Briefing Packet"
        value="BP"
        checked // By default Briefing Packet will be checked
      />

      <RadioComponent
        componentName="packet"
        label="Takeoff Performance Report Only"
        value="PERFONLY"
      />

      {/* Will be shown only if the selected airline is QX */}
      {airlineTypeData === AirlineType.QX && (
        <RadioComponent componentName="packet" label="WX Only" value="THRUWX" />
      )}

      {/* Will be shown only if the selected airline is QX */}
      {airlineTypeData === AirlineType.QX && (
        <RadioComponent
          componentName="packet"
          label="WX and Takeoff Performance Report"
          value="PERFANDTHRUWX"
        />
      )}

      <RadioComponent componentName="packet" label="Release" value="RL" />

      <RadioComponent componentName="packet" label="Flight Plan" value="FP" />

      {/* Will be shown only if the selected airline is AS */}
      {airlineTypeData === AirlineType.AS && (
        <RadioComponent
          componentName="packet"
          label="Release and WX"
          value="RLANDTHRUWX"
        />
      )}

      <RadioComponent
        componentName="packet"
        label="Release and Flight Plan"
        value="RLANDFP"
      />
    </>
  );

  return (
    <Card stepNumber={2} title="Select a packet type">
      <auro-radio-group
        required
        onClick={handlePacketRadioData}
        error={
          // When valid error should be undefined else show the error message
          reqValidity.packetType
            ? undefined
            : 'Please select the type of packet'
        }
        data-testid="radio-group-packet"
        disabled={packetReqLoading ? true : undefined}
      >
        {packetTypeOptions}
      </auro-radio-group>
    </Card>
  );
};

export default Packet;
